import { CustomPlayerMetric } from "@/types/metric"
import { numberFormat } from "@/utils/number"

/**
 * Threshold 로 고른 Zone 의 구간 값 텍스트 (#171 / ERR-026 / 정본 web-g2-f0 "선택 시 해당 구간 값 확인 가능").
 *
 * 팀 Zone 설정(global)은 각 Zone 의 시작값을 담고 있고 다음 Zone 의 시작값이 끝값이다.
 *   Speed Zone 4 (19.8) → 다음 Zone 시작 25.2  ⇒ "19.8 ~ 25.2 km/h"
 *   마지막 Zone            ⇒ "25.2 km/h ~"
 * Vue→React 전환(WEB-1246) 때 빠진 옛 ActionRow 의 action-threshold-range 표시를 복구한 것.
 */
const zoneIndexOf = (code: string): number => {
  const match = code.match(/(\d+)$/)

  return match ? Number(match[1]) : Number.POSITIVE_INFINITY
}

export function getThresholdRangeText(
  zones: CustomPlayerMetric[] | undefined,
  thresholdZoneCode: string | undefined,
  unit: string,
  decimalPoint = 1,
): string | null {
  if (!zones?.length || !thresholdZoneCode) {
    return null
  }

  // API 순서에 의존하지 않도록 코드 끝 숫자(speedZone0, speedZone1 …)로 정렬
  const ordered = [...zones].sort((a, b) => zoneIndexOf(a.code) - zoneIndexOf(b.code))
  const index = ordered.findIndex((zone) => zone.code === thresholdZoneCode)

  if (index < 0) {
    return null
  }

  const lower = numberFormat(Number(ordered[index].value), decimalPoint)
  const next = ordered[index + 1]
  const unitText = unit ? ` ${unit}` : ""

  if (!next) {
    return `${lower}${unitText} ~`
  }

  return `${lower} ~ ${numberFormat(Number(next.value), decimalPoint)}${unitText}`
}
